import { z } from 'zod';

import { buildQueryString } from '../../utils/querystring';
import { financialSummaryGroupingOptions } from '../brand/financial';
import { makeEndpoint, MinimalHostSchema, paginateQuerySchema, paginateResponseSchema } from '../common';
import { IMediaReferenceSchema } from '../media/media';
import { BrandSchema } from '../user/user';

export const BrandsLogisticSummarySchema = z
  .object({
    brandId: z.string(),
    host: MinimalHostSchema.optional(),
    brand: BrandSchema.pick({ id: true, name: true }).extend({ logo: IMediaReferenceSchema.nullable() }).optional(),
    experience: z.object({ id: z.string(), title: z.string(), coverPicture: IMediaReferenceSchema.nullable() }).optional(),
    resourceGroup: z
      .object({
        id: z.string(),
        resourceGroupCollectionId: z.string(),
        title: z.string(),
        coverPicture: IMediaReferenceSchema.nullable(),
      })
      .optional(),
    totalParticipants: z.string(),
    averageParticipants: z.string(),
    averageBookingWindowInMinutes: z.string(),
    totalBookings: z.string(),
  })
  .strict();

const BrandsLogisticSummaryResponseSchema = paginateResponseSchema(BrandsLogisticSummarySchema).strict();

const GetBrandsLogisticsSummaryQuerySchema = paginateQuerySchema({
  sortBy: ['totalParticipants', 'averageBookingWindowInSeconds', 'totalBookings'],
}).extend({
  groupBy: z.enum(financialSummaryGroupingOptions),
});

export const GetBrandsLogisticsSummaryEndpoint = makeEndpoint({
  method: 'GET',
  url: ({
    entityType,
    entityId,
    query,
  }: {
    entityType: string;
    entityId: string;
    query: z.input<typeof GetBrandsLogisticsSummaryQuerySchema>;
  }) => `v1/${entityType}/${entityId}/logistics?${buildQueryString(query)}`,
  responseSchema: BrandsLogisticSummaryResponseSchema,
  requestSchema: z.void(),
  querySchema: GetBrandsLogisticsSummaryQuerySchema,
});
